import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppSettingsState } from './app-settings.models';
import { APP_SETTINGS_FEATURE_KEY } from './app-settings.reducer';

export const selectAppSettingsState = createFeatureSelector<AppSettingsState>(
  APP_SETTINGS_FEATURE_KEY
);

export const selectAppSettingsLoaded = createSelector(
  selectAppSettingsState,
  (state: AppSettingsState) => state.loaded
);

export const selectAppSettingsError = createSelector(
  selectAppSettingsState,
  (state: AppSettingsState) => state.error
);

export const selectHeaderText = createSelector(
  selectAppSettingsState,
  (state: AppSettingsState) => state.headerText
);

export const selectcurrentUrl = createSelector(
  selectAppSettingsState,
  (state: AppSettingsState) => state.currentUrl
);
